import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]
  static values  = { delay: { type: Number, default: 300 } }

  connect() {
    this._timer = null
  }

  search() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
